import { Input, MultiSearchForm, useDebouncedSearch } from "@";
import { searchValues } from "../utils/options";

// Component for rendering the multi-search form
const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      onSubmit={onSubmit}
      show={search.show}
      className="multi-search-form"
      reset={() => updateSearch({ values: searchValues })}
    >
      <Input
        value={search.values.messageTitle}
        change={(e) => handleInputChange("messageTitle", e.target.value)}
        label="عنوان الرسالة"
        star
      />

      <Input
        value={search.values.phoneNumber}
        change={(e) => handleInputChange("phoneNumber", e.target.value)}
        label="رقم الهاتف"
        star
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
